import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import styled from "styled-components";
import { makeStyles, IconButton, useMediaQuery } from "@material-ui/core";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { notArrayOrEmpty } from "../../../utils/helpers";
import RoutesSummary from '../../Common/RoutesSummary';

const Container = styled.div`
    position: absolute;
    top: 2px;
    left 5px;
    z-index: 401;
    min-height: 33;
    display: flex;
    justify-content: flex-start;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 10px 10px;
    display: ${props => props.visible ? "normal" : "none"};
    max-width: ${props => props.collapse ? "50px" : "inherit"};
`;

const styles = makeStyles(theme => ({
    text: {
        margin: theme.spacing(1),
        color: "#000"
    },
    pointer: {
        cursor: "pointer",
        padding: 0,
        color: "#000"
    },
    content: {
        display: "flex",
        [theme.breakpoints.down('md')]: {
            flexDirection: "column"
        },
    }
}));

const SelectedRoutesSummary = ({ selectedRoutes }) => {
    const classes = styles();
    const [collapsed, setCollapsed] = useState(false);
    const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('md'));

    return (
        <Container
            visible={!notArrayOrEmpty(selectedRoutes)}
            collapse={collapsed}
            small={isSmallScreen}
        >
            {
                !collapsed
                &&
                <div className={classes.content}>
                    <RoutesSummary
                        routes={selectedRoutes}
                        typographyClassName={classes.text}
                    />
                </div>
            }
            <IconButton
                onClick={() => setCollapsed(prev => !prev)}
                className={classes.pointer}
            >
                {!collapsed ? <ChevronLeftIcon /> : <ChevronRightIcon/>}
            </IconButton>
        </Container>
    );
};

const mapStateToProps = (state) => ({
    selectedRoutes: state.mapRoutesReducer.selectedRoutes
});


SelectedRoutesSummary.propTypes = {
    //redux
    selectedRoutes: PropTypes.array
};

export default connect(
    mapStateToProps
)(SelectedRoutesSummary);
